import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.updateHeight()

    // Update on window resize
    this.resizeObserver = new ResizeObserver(() => {
      this.updateHeight()
    })
    this.resizeObserver.observe(this.element)
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  updateHeight() {
    const height = this.element.offsetHeight

    if (this.element.classList.contains('fixed-bottom')) {
      document.documentElement.style.setProperty('--fixed-bottom-height', `${height}px`)
    }

    if (this.element.classList.contains('fixed-top')) {
      document.documentElement.style.setProperty('--fixed-top-height', `${height}px`)
    }
  }
}
